module.exports = __webpack_public_path__ + "img/uniswap_logo_title.38ba9759.svg";